<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
<div class="headerdiv">
  <div>
    <h3 class="pagetitle">Dashboard</h3>
    <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
  </div>
</div>

<div class="row ">
  <div class="col-8 mx-auto ">
    <mat-card>
      <mat-form-field [formGroup]="range" appearance="outline" style="margin-left: 10px;">
        <mat-label>Enter a date range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input formControlName="start_date" matStartDate placeholder="Start date">
          <input formControlName="end_date" matEndDate placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <button mat-button style="margin-left:10px" (click)="getDashboard1()">Submit Date</button>
      <div class="row">
        <div class="flex-item chartcontainer">
          <!-- https://swimlane.gitbook.io/ngx-charts/examples/number-card-chart -->
          <div style="display: block;">
            <div class="pie-chart-parent">
              <ngx-charts-number-card [scheme]="colorScheme" [results]="single" [cardColor]="cardColor"
                (select)="onSelect($event)">
              </ngx-charts-number-card>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <!-- https://swimlane.gitbook.io/ngx-charts/examples/line-area-charts/line-chart -->
        <div class="flex-item chartcontainer">
          Filter by:
          <button mat-button (click)="submitDay()" >Day</button>
          <button mat-button (click)="submitWeek()" >Week</button>
          <button mat-button (click)="submitMonth()" >Month</button>
          <button mat-button (click)="submitYear()" >Year</button>
          <div>
            <label class="tableheadertitle">Visitors / Users Overview</label><br>
            <div class="pie-chart-parent">
              <ngx-charts-line-chart [view]="view" [scheme]="colorSchemeLines" [legend]="legend"
                [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxis]="xAxis" [yAxis]="yAxis"
                [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel" [timeline]="timeline" [results]="multi"
                (select)="onSelect($event)" (activate)="onActivate($event)" (deactivate)="onDeactivate($event)">
              </ngx-charts-line-chart>
            </div>
          </div>
        </div>


        <!-- https://swimlane.gitbook.io/ngx-charts/examples/bar-charts/vertical-bar-chart -->
        <div class="flex-item chartcontainer">
          <div>
            <label class="tableheadertitle">Most Viewed Events</label><br>
            <div class="pie-chart-parent">
              <ngx-charts-bar-vertical [view]="view" [scheme]="colorSchemeBar" [results]="topevents"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabelBar"
                [showYAxisLabel]="showYAxisLabelBar" [xAxisLabel]="xAxisLabelBar" [yAxisLabel]="yAxisLabelBar"
                [barPadding]="100" [gradient]="true" (select)="onSelect($event)">
              </ngx-charts-bar-vertical>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <div class="col-4">
    <mat-card>
      <div class="chartcontainer">
        <label class="totalevents">Total Events</label><label routerLink='/admin/allevents' class="showall">Show
          All</label><br>
        <label class="totaleventsnumber">{{dashboard4.totalEvents}}</label><br>
        <label class="totaleventorganizers">Total Event Organizers</label><br>
        <label class="totaleventorganizersnumber">{{dashboard4.totalOrganizers}}</label><br>

      </div>
      <div class="chartcontainer">
        <label class="totalevents">Total Payments Received</label><label routerLink='/admin/sponsoredevents'
          class="showall">Show All</label><br>
        <label class="totaleventsnumber">{{dashboard4.paymentReceived}}</label>
      </div>
      <div class="chartcontainer">
        <div class="row">
          <div class="w3-container">
            <label class="totaleventorganizers">Top Event Organizers</label>
            <p>List of our top organizers with the number of events they created</p>
            <ul class="w3-ul w3-card-4" >
              <li  *ngFor="let el of dashboard4.topEventOrganizers"  class="w3-bar" style="width: 100%;">
                <img src="{{el.avatar}}" class="avatar" >
                <div class="w3-bar-item">
                  <span class="w3-large">{{el.first_name}} {{el.last_name}}</span><br>
                  <span>{{el.events_count}} events</span>
                </div>
                <a matTooltip="{{el.email}}" href="mailto:{{el.email}}"><span class="material-icons emailicon">mail</span></a>

              </li>


            </ul>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
</div>